import ImageModel from "../models/ImageModel";

class CacheStore {
  constructor() {
    this.urls = new Map();
  }
}

const globalCache = new CacheStore();

const ImageViewModel = {
  getSignedImageUrl: async (imageKey, forceRefresh = false) => {
    if (!forceRefresh && globalCache.urls.has(imageKey)) {
      return { url: globalCache.urls.get(imageKey), isCached: true };
    }

    try {
      const url = await ImageModel.fetchSignedUrl(imageKey, forceRefresh);
      globalCache.urls.set(imageKey, url);
      return { url, isCached: false };
    } catch (error) {
      console.error("Error fetching signed URL in ViewModel:", error);
      throw error;
    }
  },

  invalidate: (imageKey) => {
    globalCache.urls.delete(imageKey);
  },
};

export default ImageViewModel;
